// Motif zellige simplifié en arrière-plan (opacité faible)
export const Zellige = ({ className = "text-terracotta", opacity = "opacity-[0.05]" }) => (
  <svg
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 h-full w-full ${opacity} ${className}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <pattern id="zellige" width="80" height="80" patternUnits="userSpaceOnUse">
        <path d="M40 0L80 40L40 80L0 40Z" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="40" cy="40" r="10" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M40 30L50 40L40 50L30 40Z" fill="currentColor" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#zellige)" />
  </svg>
);
